// App.js
import React from 'react';
import { FaHome, FaBuilding, FaPaintRoller } from 'react-icons/fa';

import NewsCard from '../NewsCard';

const App = () => {
    return (
        <div style={{ 
            // display:'grid',
            // gridTemplateColumns:'1fr 1fr 1fr',
            display: 'flex',
            justifyContent: 'center',
            gap:'20px',
            padding:'40px' 
        }}>
            <NewsCard
                image="https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
                icon={<FaHome size={24} color="white" />}
                title="Residential Construction"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore..."
                active
            />
            <NewsCard
                image="https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
                icon={<FaBuilding size={24} color="white" />}
                title="Commercial Construction"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore..."
            />
            <NewsCard
                image="https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80"
                icon={<FaPaintRoller size={24} color="white" />}
                title="Renovations and Remodeling"
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore..."
            />
         </div>
    );
};

export default App;
